<template>
    <div class="cookie_bar" v-if="show">
        <cookie-modal v-if="type === 'modal'" @confirm="confirm"></cookie-modal>
        <cookie-banner v-else @confirm="confirm"></cookie-banner>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import CookieModal from './CookieModal.vue';
    import CookieBanner from './CookieBanner.vue';

    @Component({
        components: {
            CookieModal,
            CookieBanner
        }
    })
    export default class CookieNotification extends Vue {
        name = 'cookie-notification';

        show = false;
        type = 'banner';

        created() {
            var local = this.getLocalStorage();
            if (this.$config.cookies.enabled && !local) {
                this.show = true;
                this.type = this.$config.cookies.type;
            }
        }

        getLocalStorage() {
            var item = localStorage.getItem('cookies');
            if (!item) {
                return false;
            } else {
                return JSON.parse(item);
            }
        }

        mounted() {
            if (this.type === 'modal') {
                this.$modal.show('cookie-modal');
            }
        }

        confirm() {
            localStorage.setItem('cookies', true);
            this.show = false;
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/cookies/CookieNotification.vue